
import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from 'src/composables/auth';


function passRouteToProps(route){
	return {
		queryParams: route.query,
		fieldName: route.params.fieldName, 
		fieldValue: route.params.fieldValue
	}
}


let routes = [
	//Dashboard routes


//permissions routes
			{
				path: '/permissions/:fieldName?/:fieldValue?',
				name: 'permissionslist',
				component: () => import('./pages/permissions/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/permissions/view/:id', 
				name: 'permissionsview', 
				component: () => import('./pages/permissions/view.vue'), 
				props: true
			},
		
			{ 
				path: '/permissions/add', 
				name: 'permissionsadd', 
				component: () => import('./pages/permissions/add.vue'), 
				props: true
			},
	
			{ 
				path: '/permissions/edit/:id', 
				name: 'permissionsedit', 
				component: () => import('./pages/permissions/edit.vue'), 
				props: true
			},
		

//roles routes
			{
				path: '/roles/:fieldName?/:fieldValue?',
				name: 'roleslist',
				component: () => import('./pages/roles/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/roles/view/:id', 
				name: 'rolesview', 
				component: () => import('./pages/roles/view.vue'), 
				props: true
			},
		
			{ 
				path: '/roles/add', 
				name: 'rolesadd', 
				component: () => import('./pages/roles/add.vue'), 
				props: true
			},
	
			{ 
				path: '/roles/edit/:id', 
				name: 'rolesedit', 
				component: () => import('./pages/roles/edit.vue'), 
				props: true
			},
		

//tbdaerah routes

//tbdaftarcalon routes
			{
				path: '/tbdaftarcalon/:fieldName?/:fieldValue?',
				name: 'tbdaftarcalonlist',
				component: () => import('./pages/tbdaftarcalon/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbdaftarcalon/view/:id', 
				name: 'tbdaftarcalonview', 
				component: () => import('./pages/tbdaftarcalon/view.vue'), 
				props: true
			},
		
			{ 
				path: '/tbdaftarcalon/add', 
				name: 'tbdaftarcalonadd', 
				component: () => import('./pages/tbdaftarcalon/add.vue'), 
				props: true
			},
	
			{ 
				path: '/tbdaftarcalon/edit/:id', 
				name: 'tbdaftarcalonedit', 
				component: () => import('./pages/tbdaftarcalon/edit.vue'), 
				props: true
			},
		
			{
				path: '/tbdaftarcalon/listmarkahcalon/:fieldName?/:fieldValue?',
				name: 'tbdaftarcalonlistmarkahcalon',
				component: () => import('./pages/tbdaftarcalon/listmarkahcalon.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbdaftarcalon/adddaftarbaru', 
				name: 'tbdaftarcalonadddaftarbaru', 
				component: () => import('./pages/tbdaftarcalon/adddaftarbaru.vue'), 
				props: true
			},
	
			{ 
				path: '/tbdaftarcalon/editcalon/:id', 
				name: 'tbdaftarcaloneditcalon', 
				component: () => import('./pages/tbdaftarcalon/editcalon.vue'), 
				props: true
			},
		
			{
				path: '/tbdaftarcalon/listlaporansek/:fieldName?/:fieldValue?',
				name: 'tbdaftarcalonlistlaporansek',
				component: () => import('./pages/tbdaftarcalon/listlaporansek.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{
				path: '/tbdaftarcalon/listlaporanppd/:fieldName?/:fieldValue?',
				name: 'tbdaftarcalonlistlaporanppd',
				component: () => import('./pages/tbdaftarcalon/listlaporanppd.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{
				path: '/tbdaftarcalon/listlaporanadmin/:fieldName?/:fieldValue?',
				name: 'tbdaftarcalonlistlaporanadmin',
				component: () => import('./pages/tbdaftarcalon/listlaporanadmin.vue'), 
				props: route => passRouteToProps(route)
			},
	

//tbdaftarsek routes
			{
				path: '/tbdaftarsek/:fieldName?/:fieldValue?',
				name: 'tbdaftarseklist',
				component: () => import('./pages/tbdaftarsek/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbdaftarsek/view/:id', 
				name: 'tbdaftarsekview', 
				component: () => import('./pages/tbdaftarsek/view.vue'), 
				props: true
			},
		
			{ 
				path: '/tbdaftarsek/add', 
				name: 'tbdaftarsekadd', 
				component: () => import('./pages/tbdaftarsek/add.vue'), 
				props: true
			},
	
			{ 
				path: '/tbdaftarsek/edit/:id', 
				name: 'tbdaftarsekedit', 
				component: () => import('./pages/tbdaftarsek/edit.vue'), 
				props: true
			},
		
			{
				path: '/tbdaftarsek/listdaftaradmin/:fieldName?/:fieldValue?',
				name: 'tbdaftarseklistdaftaradmin',
				component: () => import('./pages/tbdaftarsek/listdaftaradmin.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{
				path: '/tbdaftarsek/listsemak/:fieldName?/:fieldValue?',
				name: 'tbdaftarseklistsemak',
				component: () => import('./pages/tbdaftarsek/listsemak.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{
				path: '/tbdaftarsek/listsekolah/:fieldName?/:fieldValue?',
				name: 'tbdaftarseklistsekolah',
				component: () => import('./pages/tbdaftarsek/listsekolah.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbdaftarsek/viewsekolah/:id', 
				name: 'tbdaftarsekviewsekolah', 
				component: () => import('./pages/tbdaftarsek/viewsekolah.vue'), 
				props: true
			},
		
			{ 
				path: '/tbdaftarsek/editsek/:id', 
				name: 'tbdaftarsekeditsek', 
				component: () => import('./pages/tbdaftarsek/editsek.vue'), 
				props: true
			},
		
			{
				path: '/tbdaftarsek/listpengesahan/:fieldName?/:fieldValue?',
				name: 'tbdaftarseklistpengesahan',
				component: () => import('./pages/tbdaftarsek/listpengesahan.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbdaftarsek/editpengesahan/:id', 
				name: 'tbdaftarsekeditpengesahan', 
				component: () => import('./pages/tbdaftarsek/editpengesahan.vue'), 
				props: true
			},
		
			{
				path: '/tbdaftarsek/listpengesahanaadmin/:fieldName?/:fieldValue?',
				name: 'tbdaftarseklistpengesahanaadmin',
				component: () => import('./pages/tbdaftarsek/listpengesahanaadmin.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{
				path: '/tbdaftarsek/listdashboardsek/:fieldName?/:fieldValue?',
				name: 'tbdaftarseklistdashboardsek',
				component: () => import('./pages/tbdaftarsek/listdashboardsek.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbdaftarsek/addadmin', 
				name: 'tbdaftarsekaddadmin', 
				component: () => import('./pages/tbdaftarsek/addadmin.vue'), 
				props: true
			},
	

//tbsekolah routes
			{
				path: '/tbsekolah/:fieldName?/:fieldValue?',
				name: 'tbsekolahlist',
				component: () => import('./pages/tbsekolah/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbsekolah/view/:id', 
				name: 'tbsekolahview', 
				component: () => import('./pages/tbsekolah/view.vue'), 
				props: true
			},
		
			{ 
				path: '/tbsekolah/add', 
				name: 'tbsekolahadd', 
				component: () => import('./pages/tbsekolah/add.vue'), 
				props: true
			},
	
			{ 
				path: '/tbsekolah/edit/:id', 
				name: 'tbsekolahedit', 
				component: () => import('./pages/tbsekolah/edit.vue'), 
				props: true
			},
		
			{
				path: '/tbsekolah/listsekolahadmin/:fieldName?/:fieldValue?',
				name: 'tbsekolahlistsekolahadmin',
				component: () => import('./pages/tbsekolah/listsekolahadmin.vue'), 
				props: route => passRouteToProps(route)
			},
	

//tbstatus routes

//tbstatushadir routes

//tbtahunujian routes
			{
				path: '/tbtahunujian/:fieldName?/:fieldValue?',
				name: 'tbtahunujianlist',
				component: () => import('./pages/tbtahunujian/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbtahunujian/view/:id', 
				name: 'tbtahunujianview', 
				component: () => import('./pages/tbtahunujian/view.vue'), 
				props: true
			},
		
			{ 
				path: '/tbtahunujian/add', 
				name: 'tbtahunujianadd', 
				component: () => import('./pages/tbtahunujian/add.vue'), 
				props: true
			},
	
			{ 
				path: '/tbtahunujian/edit/:id', 
				name: 'tbtahunujianedit', 
				component: () => import('./pages/tbtahunujian/edit.vue'), 
				props: true
			},
		
			{
				path: '/tbtahunujian/listmasukmarkah/:fieldName?/:fieldValue?',
				name: 'tbtahunujianlistmasukmarkah',
				component: () => import('./pages/tbtahunujian/listmasukmarkah.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbtahunujian/viewujian/:id', 
				name: 'tbtahunujianviewujian', 
				component: () => import('./pages/tbtahunujian/viewujian.vue'), 
				props: true
			},
		

//users routes
			{
				path: '/users/:fieldName?/:fieldValue?',
				name: 'userslist',
				component: () => import('./pages/users/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/users/view/:id', 
				name: 'usersview', 
				component: () => import('./pages/users/view.vue'), 
				props: true
			},
		
			{ 
				path: '/account/edit', 
				name: 'usersaccountedit', 
				component: () => import('./pages/account/accountedit.vue'), 
				props: true
			},
	
			{ 
				path: '/account', 
				name: 'usersaccountview', 
				component: () => import('./pages/account/accountview.vue'), 
				props: true
			},
	
			{ 
				path: '/users/add', 
				name: 'usersadd', 
				component: () => import('./pages/users/add.vue'), 
				props: true
			},
	
			{ 
				path: '/users/edit/:id', 
				name: 'usersedit', 
				component: () => import('./pages/users/edit.vue'), 
				props: true
			},
		

			{ 
				path: '/konfigurasi', 
				name: 'konfigurasi', 
				component: () => import('././pages/custom/konfigurasi.vue'), 
				props: true
			},
	
	
	
	
	
	{ 
		path:  '/error/forbidden', 
		name: 'forbidden', 
		component: () => import('./pages/errors/forbidden.vue'),
		props: true
	},
	{ 
		path: '/error/notfound', 
		name: 'notfound',
		component: () => import('./pages/errors/pagenotfound.vue'),
		props: true
	},
	{
		path: '/:catchAll(.*)', 
		component: () => import('./pages/errors/pagenotfound.vue')
	}
];

export default () => {
	
const auth = useAuth();

	
	const user = auth.user;
	if(user){
		const roleName = auth.userRole.toLowerCase();
		let rolePage;
		switch(roleName){
			case "ppd":
				rolePage = "ppd";
				break;
			case "sekolah":
				rolePage = "sekolah";
				break;
			default:
				rolePage = "home";
		}
		
		//Dashboard route
		//Display page based on user role
		routes.push({
			path: '/',
			alias: '/home', 
			name: 'home', 
			component: () => import(`./pages/home/${rolePage}.vue`),
			props: true
		});
	}
	else{
		routes.push({
			path: '/', 
			alias: '/index', 
			name: 'index', 
			component: () => import('./pages/index/index.vue'),
			props: true
		});
	}

	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion){
			if(savedPostion) return savedPostion;
			return { top:0 }
		}
	});
	
	router.beforeEach((to, from, next) => {
		const user = auth.user;
		let path = to.path;
		let authRequired = auth.pageRequiredAuth(path);
		if (authRequired) {
			if(!user){
				return next({ path: '/',  query: { nexturl: to.fullPath } });
			}
			//authorize user
			if (!auth.canView(path)) {
				return next({path: "/error/forbidden"});
			}
		}

		if(user && to.name == "index"){
			//already logged in, show home when try to access index page
			return next({ path: "/home"});
		}

		//navigate to redirect url if available
		if(to.name == "home" && to.query.nexturl){
			return next({ path: to.query.nexturl});
		}

 		//close dialog from previous page
		//store.closeDialogs('app/closeDialogs');
		
		next();
	});

	return router;
}
